import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Navigation, Store, Calendar, TrendingDown } from "lucide-react";
import PageHero from "@/components/PageHero";
import client, { money } from "@/lib/api";
import { Skeleton } from "@/components/ui/skeleton";

export default function Trips() {
  const navigate = useNavigate();
  const [trips, setTrips] = useState(null);
  useEffect(() => { client.get("/trips").then((r) => setTrips(r.data)).catch(() => setTrips([])); }, []);

  const totalSaved = (trips || []).reduce((s, t) => s + (t.saved || 0), 0);

  return (
    <div className="space-y-5">
      <PageHero image="/img/cart.jpg" eyebrow="Trip history" title="Your trips" subtitle="Every run, every store, every dollar saved." testId="trips-hero" />

      <div className="bg-pp-forest text-white rounded-3xl p-6 pp-shadow flex items-center justify-between">
        <div><p className="text-white/70 text-sm">Total saved with Pantry Pilot</p><p className="text-4xl font-extrabold text-pp-gold">{money(totalSaved)}</p></div>
        <TrendingDown className="h-12 w-12 text-white/40" />
      </div>

      {!trips ? [...Array(3)].map((_, i) => <Skeleton key={i} className="h-24 rounded-3xl" />) :
        trips.length === 0 ? (
          <div className="bg-white rounded-3xl p-10 text-center pp-shadow" data-testid="empty-trips">
            <Navigation className="h-12 w-12 mx-auto text-pp-fresh" />
            <p className="mt-3 font-bold text-pp-text">No trips yet</p>
            <p className="text-pp-muted text-sm">Build a list and start your first optimized trip.</p>
          </div>
        ) : trips.map((t) => (
          <button key={t.id} data-testid={`trip-row-${t.id}`} onClick={() => t.status === "active" && navigate(`/trip/${t.id}`)}
            className="w-full text-left bg-white rounded-3xl p-5 pp-shadow flex items-center gap-4 hover:pp-shadow-lg transition-shadow">
            <span className="grid place-items-center h-12 w-12 rounded-2xl bg-[#EBF7EE] text-pp-forest"><Store className="h-6 w-6" /></span>
            <div className="flex-1 min-w-0">
              <p className="font-bold text-pp-text truncate">{(t.store_names || []).join(", ") || "Shopping trip"}</p>
              <p className="text-sm text-pp-muted flex items-center gap-1"><Calendar className="h-3.5 w-3.5" /> {new Date(t.date).toLocaleDateString()} · {t.num_stores} store{t.num_stores > 1 ? "s" : ""}
                {t.status === "active" && <span className="ml-2 rounded-full bg-pp-gold/20 text-[#8A5F00] text-xs font-bold px-2">In progress</span>}</p>
            </div>
            <div className="text-right">
              <p className="font-extrabold text-pp-text">{money(t.actual_total ?? t.planned_total)}</p>
              <p className="text-sm font-semibold text-pp-forest">saved {money(t.saved)}</p>
            </div>
          </button>
        ))}
    </div>
  );
}
